import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { VisitorApi } from "./utils/VisitorApi";
import { StopTraversalException } from "./utils/StopTraversalException";
import { VisitorPath } from "./path";
export var VisitorContext = /*#__PURE__*/function () {
  function VisitorContext(traverseApi, state) {
    var _this = this;
    _classCallCheck(this, VisitorContext);
    this.traverseApi = traverseApi;
    this.state = state;
    _defineProperty(this, "skipped", false);
    _defineProperty(this, "path", void 0);
    // private needsPostProcess: boolean[] = [];
    _defineProperty(this, "postProcessingDepth", -1);
    _defineProperty(this, "visitorApi", void 0);
    _defineProperty(this, "publicApi", {
      executeChange: function executeChange(changeFn) {
        _this.runPreProcessing();
        changeFn();
      },
      skip: function skip() {
        _this.skipped = true;
      },
      stop: function stop() {
        throw new StopTraversalException();
      }
    });
    this.visitorApi = new VisitorApi(traverseApi, this.publicApi);
  }
  _createClass(VisitorContext, [{
    key: "enter",
    value: function enter(node, params) {
      this.path = new VisitorPath(node, params, this.path);
      this.visitorApi.call('enterChild', this.path, this.state);
      if (!this.skipped) this.visitorApi.call('enter', this.path, this.state);
    }
  }, {
    key: "exit",
    value: function exit() {
      var _this$path;
      if (!this.path) return;
      this.visitorApi.call('exit', this.path, this.state);
      this.visitorApi.call('exitChild', this.path, this.state);
      this.runPostProcessing();
      this.path = (_this$path = this.path) === null || _this$path === void 0 ? void 0 : _this$path.parent;
      this.skipped = false;
    }
  }, {
    key: "setNeedsPostProcess",
    value: function setNeedsPostProcess() {}
  }, {
    key: "runPostProcessing",
    value: function runPostProcessing() {
      if (!this.path) return;
      if (this.postProcessingDepth > this.path.depth && 'onChildDidChange' in this.path.node && typeof this.path.node.onChildDidChange === 'function') {
        this.path.node.onChildDidChange(this.path.params);
      }
    }
  }, {
    key: "runPreProcessing",
    value: function runPreProcessing() {
      if (!this.path) return;
      this.postProcessingDepth = this.path.depth;
      var path = this.path;
      while (path.parent) {
        path = path.parent;
        if ('onChildWillChange' in path.node && typeof path.node.onChildWillChange === 'function') {
          path.node.onChildWillChange(_objectSpread(_objectSpread({}, this.state.opts), path.params));
        }
      }
    }
  }]);
  return VisitorContext;
}();